export const getInnerText = (strHtml: string) => {
    var div = document.createElement("div");
    div.innerHTML = strHtml;
    var text = div.textContent || div.innerText || "";
    return text;
}


// WEBPACK FOOTER //
// ./src/utils/TS/Utils.ts